import React, { Component } from 'react';
import { connect } from 'react-redux';
import './TimeEntry.css';
import { ASSETS_FOLDER } from '../../../../../../constants';
import { setSubSection } from '../../../../../../redux/actions';
import EntryGroup from './EntryGroup/EntryGroup';
import * as Features from '../../../../../../utils/Features';
import { SUB_SECTION_VIDEO } from '../../../../../../content';

class TimeEntry extends Component {
  constructor(props) {
    super(props);

    this.handleClickBullet = this.handleClickBullet.bind(this);
  }

  // ----------------------------------------------------
  // Click - special
  // ----------------------------------------------------

  handleClickBullet() {
    this.props.setSubSection(this.props.data.section);
  }

  // ----------------------------------------------------
  // Render
  // ----------------------------------------------------

  render() {
    const {
      data,
      hoveredSpot,
      lastOpenSpot,
      position,
      completeVideos,
    } = this.props;
    const { pos, timeline } = this.props.data;
    const isSpecial = timeline === undefined;
    const style = {
      left: `${pos * 100}%`,
    };

    // check state
    const active = hoveredSpot === position;
    const lastOpen = lastOpenSpot === position;
    const isDone =
      isSpecial &&
      completeVideos.indexOf(SUB_SECTION_VIDEO[data.section]) !== -1;

    return (
      <div
        className={`time-entry ${active ? 'active' : ''} ${
          lastOpen ? 'last' : ''
        } ${isDone ? 'done' : ''}`}
        style={style}
      >
        <div className="bullet">
          {isSpecial && (
            <button
              className={`bullet-button ${
                Features.features.mobile ? 'mobile' : 'desktop'
              }`}
              onClick={this.handleClickBullet}
            >
              <img
                className="ico-base"
                src={`${ASSETS_FOLDER}img/ico/bullet-line-cross.png`}
                alt=""
              />
              <img
                className="ico-hover"
                src={`${ASSETS_FOLDER}img/ico/bullet-line-play.png`}
                alt=""
              />
            </button>
          )}
        </div>
        {!isSpecial && (
          <React.Fragment>
            <EntryGroup position={1} active={active} data={timeline.top} />
            <EntryGroup position={-1} active={active} data={timeline.bottom} />
          </React.Fragment>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  hoveredSpot: state.app.hoveredSpot,
  lastOpenSpot: state.app.lastOpenSpot,
  completeVideos: state.app.completeVideos,
});

const mapDispatchToProps = dispatch => ({
  setSubSection: sectionId => dispatch(setSubSection(sectionId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(TimeEntry);



// WEBPACK FOOTER //
// ./src/components/App/Dukla/Scene/Timeline/TimeEntry/TimeEntry.js